import { Button } from '../button'

export default function OfferCancelled({ onClose }) {
  return (
    <div className='offerCancelled flex flexDirectionColumn alignCenter'>
      <h2>Offer Cancelled</h2>
      <p className='description'>Offer was cancelled by the user</p>
      <div className='buttonsContainer flex justifyCenter'>
        <Button onClick={onClose}>Close</Button>
      </div>

      <style jsx>{`
        .offerCancelled {
          justify-content: center;
          width: 100%;
          height: 100%;
        }

        h2 {
          font-size: 3.2rem;
        }

        .description {
          margin: 1.26rem 0 2.3rem;
          text-align: center;
          font-size: 1.6rem;
        }

        .buttonsContainer {
          max-width: 39.8rem;
          width: 100%;
          margin: 2rem 0 0;

          :global(button) {
            width: 19.1rem;
            margin: 0 0.8rem;
          }
        }

        @media (max-width: 1024px) {
          .offerCancelled {
            justify-content: flex-start;
          }

          h2 {
            margin-top: 1.5rem;
            font-size: 1.8rem;
          }

          .description {
            margin: 0.5rem 0 1rem;
            font-size: 1.4rem;
          }

          .buttonsContainer {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            z-index: 1;
            width: 100%;
            margin: 0;
            padding: 0 1.3rem;

            :global(button) {
              width: 100%;
            }
          }
        }
      `}</style>
    </div>
  )
}
